import createReactComponent from '../createReactComponent';
export default createReactComponent('move-horizontal', 'MoveHorizontal', [["path",{"d":"m18 8 4 4m0 0-4 4m4-4H2m4-4-4 4m0 0 4 4","key":"svg-0"}]]);